import React, { ReactElement } from 'react';

import {
  Breakpoints,
  CTA,
  TextAppearance,
  TextColor,
  TextCustom,
  TextLineHeight,
  TextSize,
  TextType,
  TextWeight,
} from '@vw-marketing/us-components';
import { useFlags } from 'launchdarkly-react-client-sdk';

import {
  ListItemStyled,
  ListItemContentStyled,
  ListItemActionStyled,
} from './styled';
interface ListItemProps {
  actionLabel: string | ReactElement;
  active?: boolean;
  ariaLabel?: string;
  description: string | React.JSX.Element[];
  title: string | React.JSX.Element[];

  actionFunction: Function;
}

const ListItem: React.FC<ListItemProps> = ({
  active,
  title,
  description,
  actionLabel,
  actionFunction,
  ariaLabel,
}) => {
  const { ciGuidelinesRollout } = useFlags();

  return (
    <ListItemStyled
      active={active}
      ciGuidelinesRollout={ciGuidelinesRollout}
      onClick={actionFunction}
      tabIndex={0}
    >
      <ListItemContentStyled>
        <TextCustom
          appearance={TextAppearance.label150}
          style={{
            [Breakpoints.default]: {
              fontSize: TextSize.TextSize14,
              color: TextColor.primary,
              fontType: TextType.Label,
              fontWeight: TextWeight.bold,
              lineHeight: TextLineHeight.TextLineHeight24,
            },

            [Breakpoints.b1280]: {
              fontSize: TextSize.TextSize16,
              lineHeight: TextLineHeight.TextLineHeight24,
            },
          }}
        >
          {title}
        </TextCustom>
        <TextCustom
          appearance={TextAppearance.label150}
          style={{
            [Breakpoints.default]: {
              fontSize: TextSize.TextSize12,
              color: TextColor.primary,
              fontType: TextType.Label,
              fontWeight: TextWeight.light,
              lineHeight: TextLineHeight.TextLineHeight24,
            },

            [Breakpoints.b1280]: {
              fontSize: TextSize.TextSize14,
              lineHeight: TextLineHeight.TextLineHeight20,
            },
          }}
        >
          {description}
        </TextCustom>
      </ListItemContentStyled>
      <ListItemActionStyled>
        <CTA
          tag="button"
          emphasis="tertiary"
          aria-label={ariaLabel}
          tabIndex={-1}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            actionFunction();
          }}
        >
          {actionLabel}
        </CTA>
      </ListItemActionStyled>
    </ListItemStyled>
  );
};

export default ListItem;
